import { MapPin, ExternalLink } from "lucide-react";
import { useOffices } from "@/lib/offices";
import { useT } from "@/lib/i18n";

export function OfficesSection() {
  const { tk } = useT();
  const officeGroups = useOffices();
  return (
    <section id="offices" className="scroll-mt-24 border-t border-gold/15 bg-card/30">
      <div className="max-w-7xl mx-auto px-6 py-24">

        <div className="space-y-16">
          {officeGroups.map((group) => (
            <div key={group.countryCode}>
              <div className="flex items-baseline gap-3 mb-6">
                <h3 className="font-serif text-2xl">{group.country}</h3>
                <span className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground">
                  {group.offices.length}{" "}
                  {group.offices.length === 1 ? tk("offices.unit.one", "sede") : tk("offices.unit.many", "sedes")}
                </span>
                <div className="flex-1 h-px bg-gold/15 ml-3" />
              </div>
              <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {group.offices.map((o) => (
                  <a
                    key={o.slug}
                    href={o.mapUrl}
                    target="_blank"
                    rel="noreferrer noopener"
                    className={`group rounded-xl border bg-background/40 p-5 hover:border-gold/60 transition-colors flex flex-col ${
                      o.isHeadquarters ? "border-gold/60 ring-1 ring-gold/30" : "border-gold/20"
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <MapPin size={16} className="text-gold mt-1 shrink-0" />
                      <div className="min-w-0">
                        {o.isHeadquarters && (
                          <span className="inline-block mb-2 text-[9px] tracking-[0.3em] uppercase text-gold border border-gold/40 rounded-full px-2 py-0.5">
                            {tk("offices.hq", "Sede central")}
                          </span>
                        )}
                        <div className="text-sm font-medium leading-snug">{o.name}</div>
                        <div className="text-xs text-muted-foreground mt-2 leading-relaxed">{o.address}</div>
                        <div className="text-xs text-foreground/70 mt-1">
                          {o.postalCode} {o.city}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 inline-flex items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-gold/80 group-hover:text-gold">
                      {tk("offices.openMap", "Abrir en Maps")}
                      <ExternalLink size={12} />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
